module.exports = __webpack_public_path__ + "img/scroll-4.f0adc920.jpg";